// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getDashboardPanels } from "@guestsupply/App/Services/DashboardPanelsService";
import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { DashboardPanelCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<HasOnSuccess<DashboardPanelCollectionModel> & HasOnError, DashboardPanelCollectionModel>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getDashboardPanels();
    } catch (error) {
        props.parameter.onError?.(error);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult) {
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const loadDashboardPanels = createHandlerChainRunnerOptionalParameter(chain, {}, "loadDashboardPanels");
export default loadDashboardPanels;
